import { blazeDevicePromiseClient } from '~/services/blaze-device-client';

export const listFirmwares = () =>
  blazeDevicePromiseClient.listFirmwares({ pageSize: BigInt(1000) });
